import React, { useState } from 'react';

export const DonationModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="donation-overlay" onClick={onClose}>
      <div className="donation-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>✕</button>
        <div className="modal-header">
          <h3>శ్రీ సీతారామచంద్రస్వామి వారి ఆలయ నిర్మాణం</h3>
          <p>ధర్మ పరిరక్షణలో మీ వంతు భాగస్వామ్యం</p>
        </div>
        
        <div className="modal-body">
          <div className="donation-info-text">
            <p>దాతలు సమర్పించదలచిన విరాళములు వస్తురూపంలో గానీ, నగదు రూపంలో గానీ స్వయంగా కమిటీ వారికి అందజేసి, తగిన రసీదు పొందవలసిందిగా మనవి చేయుచున్నాము.</p>
            <div className="contact-highlight">
              <p>సంప్రదించవలసిన వారు : G. హనుమంతు శ్రీనివాసరావు</p>
              <p>ఫోన్ నెంబర్ : 9948988398</p>
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <p>మీరు సమర్పించే విరాళములు భగవంతుని సేవలో మరియు ఆలయ అభివృద్ధికి వినియోగించబడును.</p>
        </div>
      </div>
    </div>
  );
};

const DonationCTA = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="sticky-donation-cta" onClick={() => setIsModalOpen(true)}>
        <div className="cta-content">
          <span className="cta-text">విరాళం సమర్పించండి</span>
        </div>
      </div>
      <DonationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default DonationCTA;
